var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11.5V9M2.25 4V1.5M1 2.75H3.5M1 10.25H3.5M6.5 2L5.63291 4.25443C5.4919 4.62105 5.4214 4.80435 5.31176 4.95854C5.21459 5.0952 5.0952 5.21459 4.95854 5.31177C4.80435 5.4214 4.62105 5.49191 4.25443 5.63291L2 6.5L4.25443 7.36709C4.62105 7.50809 4.80435 7.5786 4.95854 7.68823C5.0952 7.78541 5.21459 7.9048 5.31177 8.04146C5.4214 8.19565 5.49191 8.37895 5.63291 8.74557L6.5 11L7.36709 8.74557C7.50809 8.37895 7.5786 8.19565 7.68824 8.04146C7.78541 7.9048 7.9048 7.78541 8.04146 7.68823C8.19565 7.5786 8.37895 7.50809 8.74557 7.36709L11 6.5L8.74557 5.63291C8.37895 5.49191 8.19565 5.4214 8.04146 5.31176C7.9048 5.21459 7.78541 5.0952 7.68823 4.95854C7.5786 4.80435 7.50809 4.62105 7.36709 4.25443L6.5 2Z",
    stroke: "#D3A203",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.84ee96a82bb4a6a5e4d8ffe7c5606e63.svg";
export { ForwardRef as ReactComponent };